export enum RouteAuthRequirementEnum {
  noAuthOnly = "noAuthOnly",
  authOnly = "authOnly",
  all = "all",
}
